<template>
  <div>
    <div class="container-xxl" v-show="!isReady">
      <Loader />
    </div>
    <div class="card mb-5 mb-xxl-8" v-show="isReady">
      <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
        <!--begin::Card header-->
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('store.entrie.title') }}</h3>
          </div>
          <div class="card-toolbar gap-2" v-if="store.etat == 'active'">
            <!-- Entrée en stock : par article ou par catégorie (comme la boutique) -->
            <div v-if="$can('entry_magasin_create')" class="position-relative">
              <button class="btn btn-sm btn-primary" type="button" @click.stop="entryMenuOpen = !entryMenuOpen">
                <i class="bi bi-arrow-down-circle me-1"></i>{{ $t('store.entrie.make_entry') }}
                <i class="bi bi-chevron-down ms-1 fs-8"></i>
              </button>
              <div v-if="entryMenuOpen" class="entry-menu" @click="entryMenuOpen = false">
                <a href="#" class="entry-menu-item" @click.prevent="$refs.entryModals.open('item')">
                  <i class="bi bi-box-seam me-2"></i>{{ $t('store.entrie.add') }}
                </a>
                <a href="#" class="entry-menu-item" @click.prevent="$refs.entryModals.open('category')">
                  <i class="bi bi-tags me-2"></i>{{ $t('store.entrie.add_by_cat') }}
                </a>
              </div>
            </div>
            <router-link v-if="$can('output_magasin_create')" :to="{ name: 'store-output-create', params: { id: $route.params.id } }"
              class="btn btn-sm btn-light-warning"><i class="bi bi-arrow-left-right me-1"></i>{{ $t('store.output.add') }}</router-link>
          </div>
  
        </div>
        <div class="card-body">
  
          <!--begin::Layout-->
          <div class="row">
            <!--begin::Table-->
            <table class="table table-responsive align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_entry_output">
              <thead>
                <tr class="text-center text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                  <th class="min-w-100px">{{ $t('store.entrie.numero') }}</th>
                  <th class="min-w-100px">{{ $t('store.entrie.date') }}</th>
                  <th class="min-w-100px">{{ $t('store.entrie.type') }}</th>
                  <th class="min-w-100px">{{ $t('store.entrie.expeditor') }}</th>
                  <th class="min-w-100px">{{ $t('store.entrie.beneficiary') }}</th>
                  <th class="min-w-100px">{{ $t('store.entrie.item_number') }}</th>
                  <th class="min-w-100px">{{ $t('store.entrie.text_status') }}</th>
                  <th class="min-w-100px">{{ $t('action') }}</th>
                </tr>
              </thead>

            </table>
            <!--end::Table-->
          </div>
          <!--end::Layout-->
        </div>
        <!--end::Card body-->
      </div>
      <div class="modal fade" tabindex="-1" id="detail_bon">
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('store.entrie.detail') }}</h5>

              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-danger ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-2x">x</span>
              </div>
              <!--end::Close-->
            </div>

            <div v-show="isDisponible" class="modal-body">
              <div class="m-0">
                <div class="row g-5 mb-11">
                  <div class="col-sm-4" v-if="stockDetails?.store">
                    <div class="fw-bolder fs-3 text-gray-800">{{ stockDetails?.store?.name  }}</div>
                  </div>
                  <div class="col-sm-3" v-if="stockDetails?.date">
                    <div class="fw-bolder fs-6 text-gray-800">{{ $t('store.entrie.date') }} <span style="margin-left: 10px;">{{ stockDetails?.date }}</span></div>
                  </div>
                  <div class="col-sm-5">
                    <div class="fw-bolder fs-6 text-gray-800">{{ $t('store.entrie.number') }} <span class="text-info" style="margin-left: 10px;">#{{ stockDetails?.numero }}</span></div>
                  </div>
                  <div class="col-sm-4" v-if="type == 'output'">
                    <span v-if="stockDetails?.status == 'Send'">
                      <div class="fw-bolder fs-3 text-gray-800 mb-1">{{ $t('store.entrie.text_status') }}: <span class="text-primary" style="margin-right: 5px;">{{stockDetails?.tr_status }}</span></div>
                    </span>
                    <span v-else>
                      <div class="fw-bolder fs-3 text-gray-800 mb-1">{{ $t('store.entrie.text_status') }}: <span class="text-danger" style="margin-right: 5px;">{{
                          stockDetails?.tr_status }}</span></div>
                    </span>
                  </div>
                </div>

                <div class="container scroll"
                     data-kt-scroll="true"
                     data-kt-scroll-height="{default: }"
                     data-kt-scroll-wrappers="#kt_example_js_content"
                     data-kt-scroll-dependencies="#kt_example_js_header, #kt_example_js_footer, #kt_header"
                     data-kt-scroll-offset="80px">
                  <div class="card" v-if="type === 'entry'">
                    <div class="card-body mt-4 rounded bg-light">
                      <template v-for="(product, key) in stockDetails.items" :key="key">
                        <div class="row">
                          <div class="col-sm-5" v-if="product.product_sale_element_id">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('store.entrie.product') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center">{{ getMyName('productSale', product.product_sale_element_id) }}</div>
                          </div>
                          <div class="col-sm-2">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('shop.lot_unite') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center">{{ product.lot_id ? product.lot_name  : $t('shop.unite') }}</div>
                          </div>
                          <div class="col-sm-3">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('store.entrie.entry_quantity') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center"> {{ product.lot_quantity ? product.lot_quantity : product.quantity }}</div>
                          </div>
                          <!--                          <div class="col-sm-2">-->
                          <!--                            <div class="fw-bold text-gray-600 fs-7">{{ $t('shop.received_quantity') }}:</div>-->
                          <!--                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center">{{ product.received_quantity ? product.received_quantity : '-&#45;&#45;' }}</div>-->
                          <!--                          </div>-->
                          <hr>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="card" v-else>
                    <div class="card-body mt-4 rounded bg-light" v-for="(product, key) in stockDetails.items" :key="key">
                      <div class="row mb-4">
                        <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center"><span class="fw-bold text-gray-600 fs-7 ms-1" style="margin-right: 10px;">{{$t('store.entrie.beneficiary')}} : </span>{{ product.entity?.name }}</div>
                      </div>
                      <hr>
                      <template  v-for="(item, cles) in product.products" :key="cles">
                        <div class="row">
                          <div class="col-sm-4" v-if="item.product_sale_element_id">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('store.entrie.product') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center">{{ getMyName('productSale', item.product_sale_element_id) }}</div>
                          </div>
                          <div class="col-sm-2">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('shop.lot_unite') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center">{{ item.product_lot_id ? item.product_lot_name  : $t('shop.unite') }}</div>
                          </div>
                          <div class="col-sm-3">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('store.entrie.quantity') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center"> {{ item.product_lot_id ? item.quantity : item.quantity }}</div>
                          </div>
                          <div class="col-sm-2">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('shop.received_quantity') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center">{{ item.received_quantity ? item.received_quantity : '---' }}</div>
                          </div>
                          <div class="col-sm-1" v-if="item?.tr_status">
                            <div class="fw-bold text-gray-600 fs-7">{{ $t('product.status') }}:</div>
                            <div class="fw-bolder fs-6 text-gray-800 d-flex align-items-center"><span class="text-primary">{{ item?.tr_status }}</span></div>
                          </div>
                          <hr>
                        </div>

                      </template>


                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body loader" v-show="!isDisponible">
              <Loader text="Loading..." />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Entrée en stock (par article / par catégorie) en fenêtres, comme la boutique -->
    <StoreEntryModals ref="entryModals" :store-id="$route.params.id" @saved="onEntrySaved" />
  </div>
</template>

<script>
import { BASE_URL } from '@/services/api'
import { mapActions } from 'vuex'
import Loader from "@/components/Loader.vue";
import StoreEntryModals from "@/views/Settings/Stores/partials/StoreEntryModals.vue";
export default {
  name: "Entrie",
  components: { Loader, StoreEntryModals },
  data() {
    return {
      entryMenuOpen: false,
      getEntriesOutputs: [],
      productSaleElement: {},
      supplier: {},
      currencies: {},
      shops: {},
      formDataDelete: {
        id_entry: null,
        id: this.$route.params.id
      },
      store: {},
      stockDetails: {},
      type: 'entry',
      entry_details: {
        numero: null,
        date: null,
        items: null
      },
      isDisponible: false,
      isReady: false
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeEntryMenu)
  },
  async mounted() {
    // clic ailleurs : ferme le menu « Faire une entrée en stock »
    this.closeEntryMenu = () => { this.entryMenuOpen = false }
    document.addEventListener('click', this.closeEntryMenu)

    this.isReady = false

    this.getContactSupplier()
    this.getProductSale()
    this.loadCurrenciesLoad()
    this.loadShopsLoad()
    this.showStore(this.$route.params.id).then((response) => this.store = response.data.store )
    this.getEntryOutput(this.$route.params.id).then((response) => this.getEntriesOutputs = response.data.data )
    this.isReady = true

    this.fetchDatas();

    $(document).on('click', '#kt_datatable_entry_output .edit_btn_bon', (e) => {
      this.formDataDelete.id_output = e.target.getAttribute('data-id')
      this.$router.push({ name: 'store-output-content', params: { id: this.$route.params.id, id_content: this.formDataDelete.id_output } })
    })

    // ------------------------------------------------------------------------------------
    $(document).on('click', '#kt_datatable_entry_output .eye_btn_entry', (e) => {
      let id_entry_content = e.target.getAttribute('data-id')
      this.type = 'entry'
      this.detailProductBonModalOpen(id_entry_content)
    })

    $(document).on('click', '#kt_datatable_entry_output .eye_btn_out', (e) => {
      let id_output_content = e.target.getAttribute('data-id')
      this.type = 'output'
      this.detailProductBonModalOpen(id_output_content)
    })

    // ------------------------------------------------------------------------------------

    $(document).on('click', '#kt_datatable_entry_output .delete_btn', (e) => {
      this.formDataDelete.id_output = e.target.getAttribute('data-id')
      Swal.fire({
        text: $t('store.delete_entry'),
        icon: "error",
        showCancelButton: true,
        confirmButtonText: $t('store.delete'),
        cancelButtonText: $t('store.cancel'),
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeData();
        }
      })
    })



  },
  methods: {
    // Entrée enregistrée : recharge la liste des mouvements
    onEntrySaved() {
      this.table?.ajax.reload()
    },
    ...mapActions('store', ['removeOutputStore', 'getEntryOutput', 'showEntrieStore', 'showOutputStore', 'showStore']),
    ...mapActions('currencies', ['loadCurrencies']),
    ...mapActions('contacts', ['loadContactSupplier']),
    ...mapActions('products', ['loadProductSale']),
    ...mapActions('shop', ['loadShops']),
    async removeData() {
      let response = {}
      try {
        response = await this.removeOutputStore(this.formDataDelete)
        window.toastr['success'](i18n.global.t('notification.store.entrie_delete'))
        this.table.ajax.reload()
        this.formDataDelete.id_output = ""
      } catch (err) {

      }
    },
    detailProductBonModalOpen(id){
      if(this.type == 'entry'){
        this.entrieStoreDetails(id)
      }else{
        this.outputStoreDetails(id)
      }
      $('#detail_bon').modal('toggle')
    },

    async entrieStoreDetails(id_entry_content) {
      this.isDisponible = false
      let response = {}
      response = await this.showEntrieStore(id_entry_content)
      this.stockDetails = response.data.entrie
      this.isDisponible = true
    },

    async outputStoreDetails(id_output_content) {
      this.isDisponible = false
      let response = {}
      response = await this.showOutputStore(id_output_content)
      this.stockDetails = response.data.output
      this.isDisponible = true
    },

    async getProductSale() {
      await this.loadProductSale(this.$route.params.id).then((response) => {
        this.productSaleElement = response.data.product_sale_element
      }).catch((err) => {
        window.toastr['error'](err)
      });
    },

    async loadCurrenciesLoad() {
      await this.loadCurrencies().then((response) => {
        this.currencies = response.data.currencie
      }).catch((err) => {
        window.toastr['error'](err)
      });
    },
    async loadShopsLoad() {
      await this.loadShops({status:"active", search:""}).then((response) => {
        this.shops = response.data.shops
      }).catch((err) => {
        window.toastr['error'](err)
      });
    },
    async getContactSupplier() {
      let response = {}
      try {
        response = await this.loadContactSupplier()
        this.supplier = response.data.supplier
      } catch (e) {
        if (response && response.data) {
          window.toastr['error'](response.data.error)
        }
      }
    },
    getMyName(type, my_id){
      if(type == 'curriencie'){
        const item = this.currencies.find(item => item.id === my_id);
        return item ? item.iso : '';
      }else if(type == 'productSale'){
        const item = this.productSaleElement.find(item => item.id === my_id);
        return item?.attribut[0] ?  item?.declination_title : item?.name;
      }else if(type == 'contact'){
        const item = this.supplier.find(item => item.id === my_id);
        return item ? item.name : '';
      }else if(type == 'shop'){
        const item = this.shops.find(item => item.id === my_id);
        return item ? item.name : '';
      }else{
        return ''
      }
    },
    fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_entry_output").DataTable({
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 1, 'asc']],
        ajax: {
          url: BASE_URL + "/get/stores/" + this.$route.params.id + "/product/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {
          },
        },
        columns: [{ data: "numero" }, { data: "date" }, { data: "type" }, { data: "expeditor" }, { data: "beneficiary" }, { data: "number" }, { data: "status" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -8,
            className: "dt-center clickable text-center",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '" class="numRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -7,
            order: "desc",
            className: "dt-center clickable text-center",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '" class="numRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -6,
            order: "desc",
            className: "dt-center clickable text-center",
            render: (t, a, e, l) => {
              if (e.type == "Entry") {
                return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '"><span class="svg-icon svg-icon-3 svg-icon-success me-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="currentColor"></rect><path d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="currentColor"></path> </svg></span>' + i18n.global.t('store.entrie.status.entry') + "</span>";
              } else {
                return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '"><span class="svg-icon svg-icon-3 svg-icon-danger me-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.5" x="11" y="18" width="13" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect> <path d="M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z" fill="currentColor"></path> </svg></span>' + i18n.global.t('store.entrie.status.output') + "</span>";
              }
            },
          },
          {
            targets: -5,
            className: "dt-center clickable text-center",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="dateRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -4,
            className: "dt-center clickable text-center",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="dateRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -3,
            className: "dt-center clickable text-center",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="dateRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            className: "dt-center text-center clickable",
            render: (t, a, e, l) => {
              if (e.status == "Send") {
                return '<span data-id="' + e.id + '"  class="text-success statusRow' + l.row + '">' + i18n.global.t('store.ask.ask_status.send') + "</span>";
              } else if (e.status == "Draft") {
                return '<span data-id="' + e.id + '"  class="text-danger statusRow' + l.row + '">' + i18n.global.t('store.ask.ask_status.draft') + "</span>";
              } else {
                return '<span data-id="' + e.id + '"  class="statusRow' + l.row + '">' + t + "</span>";
              }
            },
          },

          {
            width: "10%",
            targets: -1,
            "className": "dt-center text-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = ""
              if (e.type == "Entry") {
                if(this.$can('entry_magasin_view')  ){
                  render += '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" data-numero="' + e.numero + '" class="btn btn-sm btn-clean btn-icon eye_btn_entry"><i data-row="' + l.row + '" data-id="' + e.id + '" data-numero="' + e.numero + '" data-date="' + e.date + '" class="fas fa-eye"></i></a>'

                }
                return render
              } else {

                if (e.status == "Send") {
                  if(this.$can('entry_magasin_view')  ){
                    render += '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" data-numero="' + e.numero + '" class="btn btn-sm btn-clean btn-icon eye_btn_out"><i data-row="' + l.row + '" data-id="' + e.id + '" data-numero="' + e.numero + '" data-date="' + e.date + '" class="fas fa-eye"></i></a>'

                  }
                }
                if (e.status == "Draft") {
                  if(this.$can('entry_magasin_update')  ){
                    render += '<a href="javascript:;" data-numero="' + e.numero + '" data-row="' + l.row + '" data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon edit_btn_bon"><i data-row="' + l.row + '" data-id="' + e.id + '" data-numero="' + e.numero + '" class="la la-edit"></i></a>'

                  }
                  if(this.$can('entry_magasin_view')  ){
                    render += '<a href="javascript:;" data-row="' + l.row + '" data-id="' + e.id + '" data-numero="' + e.numero + '" class="btn btn-sm btn-clean btn-icon eye_btn_out"><i data-row="' + l.row + '" data-id="' + e.id + '" data-numero="' + e.numero + '" data-date="' + e.date + '" class="fas fa-eye"></i></a>'

                  }
                }
                return render
              }
            },
          },
        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },
  }
}
</script>

<style scoped>
/* Menu « Faire une entrée en stock » */
.entry-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 105;
  min-width: 200px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.12);
  padding: 6px;
}
.entry-menu-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  color: #3f4254;
  font-weight: 500;
  font-size: 0.925rem;
}
.entry-menu-item:hover {
  background: rgba(var(--kt-primary-rgb), 0.1);
  color: var(--kt-primary);
}

.badge {
  display: none !important;
  align-items: center;
}

.badge-light-danger {
  color: #f1416c;
  background-color: #fff5f8;
  padding: 15px !important;
  text-align: center !important;
}
.loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30vh;
  background-color: #f8f8f8;
}
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>